// Self-contained data for the Concepts & Ideas Events Cebu events concept website.
export const BUSINESS = {
  "slug": "concepts-ideas-events-cebu-concept",
  "media": {
    "hero": "/events/concepts-ideas/06.jpg",
    "logo": "/events/concepts-ideas/15.jpg",
    "gallery": [
      "/events/concepts-ideas/01.jpg",
      "/events/concepts-ideas/02.jpg",
      "/events/concepts-ideas/03.jpg",
      "/events/concepts-ideas/04.jpg",
      "/events/concepts-ideas/05.jpg",
      "/events/concepts-ideas/07.jpg",
      "/events/concepts-ideas/08.jpg",
      "/events/concepts-ideas/09.jpg",
      "/events/concepts-ideas/10.jpg",
      "/events/concepts-ideas/11.jpg",
      "/events/concepts-ideas/12.jpg",
      "/events/concepts-ideas/13.jpg",
      "/events/concepts-ideas/14.jpg"
    ]
  },
  "name": "Concepts & Ideas Events Cebu",
  "shortName": "Concepts & Ideas",
  "kind": "planner",
  "layout": "creative",
  "location": "Cebu City",
  "address": "General Maxilom Avenue, Cebu City 6000, Philippines",
  "eyebrow": "Planning · styling · design",
  "headline": "Cebu celebrations designed with imagination—and handled with a plan.",
  "intro": "A trained coordination team for weddings, destination celebrations and events where visual ideas and real-world problem solving need to work together.",
  "lead": "Helbert Arsenal Canonigo",
  "leadRole": "Team leader",
  "story": "A 2025 Cebu wedding-industry profile identifies Helbert as the team’s leader and describes a background in hotel event sales. Kelvin Jay Alvarado Olimba is also publicly associated with operations and event credits.",
  "services": [
    "Wedding planning",
    "Event coordination",
    "Styling and design",
    "Destination weddings",
    "Debuts and birthdays",
    "Corporate functions",
    "Social gatherings"
  ],
  "process": [
    "Translate the couple’s brief into a local Cebu plan",
    "Shape styling, suppliers and event flow together",
    "Coordinate details while clients are overseas",
    "Adapt quickly when weather or venue conditions change"
  ],
  "proof": [
    "Team-based execution",
    "Destination-client experience",
    "Documented on-site problem solving"
  ],
  "reviewSnapshot": "Public Google rating last checked in August 2026: 4.8/5 from 12 reviews.",
  "reviews": [
    {
      "author": "Alyssa C.",
      "summary": "Planned a Cebu destination wedding from about 8,000 miles away and described the process as easy, the result as beyond expectations, and the details and staff as exceptional.",
      "source": "https://wanderlog.com/place/details/15919330/concepts-and-ideas-events-cebu",
      "explicitStars": 5,
      "context": "Destination wedding"
    },
    {
      "author": "Carol G.",
      "summary": "Highlighted the team’s effort to achieve client satisfaction.",
      "source": "https://wanderlog.com/place/details/15919330/concepts-and-ideas-events-cebu",
      "explicitStars": 5,
      "context": "Client experience"
    },
    {
      "author": "Brian C.",
      "summary": "A short review that emphasized quality over price.",
      "source": "https://wanderlog.com/place/details/15919330/concepts-and-ideas-events-cebu",
      "explicitStars": 5,
      "context": "Client experience"
    }
  ],
  "contact": {
    "phone": "+63 995 429 0236",
    "phoneHref": "+639954290236",
    "email": "candieventscebu@gmail.com",
    "facebook": "https://www.facebook.com/candieventscebu",
    "instagram": "https://www.instagram.com/candieventscebuph/"
  },
  "sources": [
    "https://www.bizippines.com/concepts-and-ideas-events-cebu-0995-429-0236",
    "https://wanderlog.com/place/details/15919330/concepts-and-ideas-events-cebu",
    "https://cebuweddingsuppliers.com/top-10-cebu-wedding-planners-and-coordinators-2025/",
    "https://www.facebook.com/candieventscebu"
  ]
};
